






























































import { Component, Watch, Prop } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import SelectCurrencies from '@/components/Accounts/DepositAccounts/Wallets/BuySellFX/BuySellFXPages/SelectCurrencies.vue';
import QuoteCountdown from '@/components/Accounts/DepositAccounts/Wallets/BuySellFX/BuySellFXPages/QuoteCountdown.vue';
import FXSummary from '@/components/Accounts/DepositAccounts/Wallets/BuySellFX/BuySellFXPages/FXSummary.vue';
import DepositAccountSummary from "@/models/Accounts/DepositAccounts/DepositAccountSummary";
import BuySellFXRequest from '@/models/Accounts/DepositAccounts/Wallets/BuySellFXRequest';
import { DepositAccountModule } from '@/store/Accounts/DepositAccountModule';
import Amount from '@/models/Shared/Amount';

@Component({ name: 'BuySellFXDialog', components: { SelectCurrencies, QuoteCountdown, FXSummary } })
export default class extends SaascadaVueDialog {

    dialog = false;
    currentPage = 1;
    buySellFXRequest: BuySellFXRequest = new BuySellFXRequest();

    @Prop({required: true})
    account: DepositAccountSummary;

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.buySellFXRequest = new BuySellFXRequest();
            this.buySellFXRequest.buySellDirection = "Selling";
            this.buySellFXRequest.feeAmount = new Amount();
            this.buySellFXRequest.feeAmount.currency = "EUR";
            this.buySellFXRequest.feeAmount.amount = "0.00";
        }
    }

    async cancel() {
        this.currentPage = 1;
        this.dialog = false;
    }

    async next() {
        if (this.currentPage === 1) {
            // Validate the form
            if (!(this.$refs.form as any).validateForm()) {
                return;
            }
            // Set the source/destination currencies depending on the selected direction
            if (this.buySellFXRequest.buySellDirection === "Selling") {
                this.buySellFXRequest.sourceAmount.currency = this.buySellFXRequest.sellCurrency;
                this.buySellFXRequest.destinationAmount.currency = this.buySellFXRequest.buyCurrency;
            }
            else {
                this.buySellFXRequest.sourceAmount.currency = this.buySellFXRequest.buyCurrency;
                this.buySellFXRequest.destinationAmount.currency = this.buySellFXRequest.sellCurrency;
            }
            // Move to the next page
            this.currentPage = 2;
        }
        else if (this.currentPage === 2) {
            this.currentPage = 3;
            await DepositAccountModule.confirmWalletBuySellFX(this.buySellFXRequest);
        }
    }

    async close() {
        this.currentPage = 1;
        this.dialog = false;
    }
}
